
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ContentSuggestion } from './types';
import ContentSuggestionCard from './ContentSuggestionCard';

interface ContentSuggestionsListProps {
  suggestions: ContentSuggestion[];
  onUseIdea: (suggestion: ContentSuggestion) => void;
}

const ContentSuggestionsList: React.FC<ContentSuggestionsListProps> = ({ 
  suggestions,
  onUseIdea 
}) => {
  return (
    <Card className="bg-background/70">
      <CardHeader className="pb-2">
        <CardTitle>Trending Content Ideas</CardTitle>
        <CardDescription>Ideas tailored to your audience and music style</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {suggestions.map((suggestion) => (
          <ContentSuggestionCard 
            key={suggestion.id}
            suggestion={suggestion}
            onUse={() => onUseIdea(suggestion)}
            onSave={(id) => console.log(`Saved suggestion ${id}`)}
          />
        ))}
      </CardContent>
      <CardFooter className="border-t bg-muted/20 justify-center py-2">
        <Button variant="link">Load more ideas</Button>
      </CardFooter>
    </Card>
  );
};

export default ContentSuggestionsList;
